export default __webpack_public_path__ + "static/media/banese_banese_page.c989ba71.png";